import {useCallback, useEffect, useState} from 'react'

import {AttachmentFile, Attachment} from '../types'

import {useFile} from './useFile'

export function useAttachmentFile(input: Attachment): AttachmentFile {
  const [source, setSource] = useState<string>('')

  const onSuccess = useCallback((response) => {
    setSource(response ? URL.createObjectURL(new Blob([response])) : '')
  }, [])

  const {data} = useFile(input.previewUrl ?? input.url, input.mediaType, input.id, {
    onSuccess
  })

  useEffect(() => {
    if (data) {
      setSource(URL.createObjectURL(new Blob([data])))
    }
  }, [data])

  return {
    id: input.id,
    name: input.fileName,
    contentType: input.mediaType,
    preview: source,
    isImage: input.mediaType.includes('image')
  }
}
